<template>
    <v-col cols="12" md="2" ma-1>
        <v-card>
            <v-card-title class="title font-weight-black">
                <v-icon class="pr-3">forward_to_inbox</v-icon> To Do
            </v-card-title>

            <v-card-text>
                <v-btn class="mt-1" block :href="toPostUrl">Gift Vouchers To Post</v-btn>
                <v-btn class="mt-1" block :href="scheduledUrl">Upcoming Electronic Deliveries</v-btn>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    /**
     * Display buttons linking through to a hotels' pages
     */
    export default {
        props:['pageid'],

        data: function() {
            return {
                toPostUrl: '/vouchers-to-post/list',
                scheduledUrl: '/upcoming-scheduled-vouchers/list',
            }
        },

        methods: {},

        computed: {}
    }
</script>
